/**
 * MENU SCENE - Pantalla de Inicio
 * Menú principal del juego
 */

import Phaser from "phaser";
import { SCENES, TEXTS, COLORS } from "../utils/constants.js";

export default class MenuScene extends Phaser.Scene {
  constructor() {
    super({ key: SCENES.MENU });
  }

  create() {
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;

    // ========================================
    // BACKGROUND DE HOME
    // ========================================
    const background = this.add.image(width / 2, height / 2, "bg_home");

    // Escalar para cubrir toda la pantalla
    const scaleX = width / background.width;
    const scaleY = height / background.height;
    const scale = Math.max(scaleX, scaleY);
    background.setScale(scale);
    background.setDepth(-1);

    console.log("🎨 Background de home cargado");

    // Fondo con gradiente
    //this.createBackground();

    // Logo oficial
    const logo = this.add.image(width / 2, height * 0.3, "logo");
    logo.setDisplaySize(300, 300); // Más grande ahora que está en el centro
    logo.setOrigin(0.5);

    this.tweens.add({
      targets: logo,
      scale: 0.3,
      duration: 2500,
      yoyo: true,
      repeat: -1,
      ease: "Sine.easeInOut",
    });

    console.log("✅ Logo oficial renderizado");

    // Tagline
    const tagline = this.add.text(width / 2, height * 0.62, TEXTS.TAGLINE, {
      fontSize: "24px",
      color: "#ffffff",
      fontFamily: "Arial",
      fontStyle: "italic",
      stroke: "#2d5016",
      strokeThickness: 4,
      backgroundColor: "#00000066",
      padding: { x: 20, y: 8 },
    });
    tagline.setOrigin(0.5);

    // Animación sutil de casa temblando (placeholder)
    //this.createHouseAnimation(width / 2, height * 0.55);

    // Botón JUGAR
    this.createPlayButton(width / 2, height * 0.75);

    // Botón ¿Cómo Jugar?
    this.createHowToButton(width / 2, height * 0.85);

    // Récord personal (si existe)
    this.showHighScore(width / 2, height * 0.95);

    console.log("🎮 Menú principal cargado");
  }

  /**
   * Crear fondo con gradiente
   */
  createBackground() {
    const graphics = this.add.graphics();
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;

    // Gradiente violeta
    graphics.fillGradientStyle(
      parseInt(COLORS.BACKGROUND.replace("#", ""), 16),
      parseInt(COLORS.BACKGROUND.replace("#", ""), 16),
      parseInt(COLORS.BACKGROUND_GRADIENT_END.replace("#", ""), 16),
      parseInt(COLORS.BACKGROUND_GRADIENT_END.replace("#", ""), 16),
      1
    );
    graphics.fillRect(0, 0, width, height);
  }

  /**
   * Crear animación de casa (placeholder)
   */
  createHouseAnimation(x, y) {
    // Por ahora, un rectángulo simple que representa la casa
    // const house = this.add.rectangle(x, y, 200, 200, 0x4d7c0f);
    // house.setStrokeStyle(4, 0x00ff00);
    // Temblor sutil
    // this.tweens.add({
    //   targets: house,
    //   x: x + 2,
    //   duration: 2000,
    //   yoyo: true,
    //   repeat: -1,
    //   ease: "Sine.easeInOut",
    // });
    // Texto temporal
    // const tempText = this.add.text(x, y, "🏛️", {
    //   fontSize: "80px",
    // });
    // tempText.setOrigin(0.5);
  }

  /**
   * Crear botón JUGAR
   */
  createPlayButton(x, y) {
    const button = this.add.rectangle(x, y, 200, 60, 0x48bb78);
    button.setStrokeStyle(4, 0xffffff);
    button.setInteractive({ useHandCursor: true });

    const buttonText = this.add.text(x, y, TEXTS.PLAY_BUTTON, {
      fontSize: "32px",
      fontWeight: "bold",
      color: "#ffffff",
      fontFamily: "Arial",
    });
    buttonText.setOrigin(0.5);

    // Efectos hover
    button.on("pointerover", () => {
      button.setFillStyle(0x5cd694);
      this.tweens.add({
        targets: [button, buttonText],
        scale: 1.1,
        duration: 100,
      });
    });

    button.on("pointerout", () => {
      button.setFillStyle(0x48bb78);
      this.tweens.add({
        targets: [button, buttonText],
        scale: 1.0,
        duration: 100,
      });
    });

    // Click - Iniciar juego
    button.on("pointerdown", () => {
      this.startGame();
    });
  }

  /**
   * Crear botón ¿Cómo Jugar?
   */
  createHowToButton(x, y) {
    const buttonText = this.add.text(x, y, TEXTS.HOW_TO_PLAY, {
      fontSize: "20px",
      color: "#ffffff",
      fontFamily: "Arial",
      stroke: "#000000",
      strokeThickness: 4,
      shadow: {
        offsetX: 2,
        offsetY: 2,
        color: "#000000",
        blur: 4,
        fill: true,
      },
    });
    buttonText.setOrigin(0.5);
    buttonText.setInteractive({ useHandCursor: true });

    // Hover effects
    buttonText.on("pointerover", () => {
      buttonText.setColor("#48bb78"); // Verde más visible
      buttonText.setScale(1.05);
    });

    buttonText.on("pointerout", () => {
      buttonText.setColor("#ffffff");
      buttonText.setScale(1.0);
    });

    buttonText.on("pointerdown", () => {
      this.showInstructions();
    });
  }

  /**
   * Mostrar récord personal
   */
  showHighScore(x, y) {
    // TODO: Cargar de localStorage cuando esté implementado
    const highScore = 0; // placeholder

    if (highScore > 0) {
      const scoreText = this.add.text(x, y, `Récord: ${highScore} ciclos`, {
        fontSize: "16px",
        color: "#cccccc",
        fontFamily: "Arial",
      });
      scoreText.setOrigin(0.5);
    }
  }

  /**
   * Iniciar el juego
   */
  startGame() {
    console.log("🎮 Iniciando juego...");

    // Transición a la escena de juego
    this.cameras.main.fade(300, 0, 0, 0);

    this.time.delayedCall(300, () => {
      this.scene.start(SCENES.GAME);
    });
  }

  /**
   * Mostrar instrucciones (placeholder)
   */
  showInstructions() {
    // TODO: Implementar modal o escena de instrucciones
    console.log("📖 Mostrar instrucciones");
    alert(
      "Instrucciones:\n\n1. Haz clic en los componentes dañados de la casa\n2. Cada clic consume 1 voto\n3. Mantén la integridad > 70% antes de que se acabe el tiempo\n4. ¡Cuidado con el deterioro automático!"
    );
  }
}
